import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6a1415e6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "nft",
  class: "modal-window modal-window-squade"
}
const _hoisted_2 = { class: "modal-content" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "madal-body" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "madal-title" }, "Lorem"),
  /*#__PURE__*/_createElementVNode("p", { class: "madal-text" }, " Lorem ipsum dolor sit, amet consectetur adipisicing elit. Voluptatum debitis distinctio ex illu ")
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { class: "btn" }, " Cansel ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("a", {
          title: "Close",
          class: "modal-close",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('closeDisbandModal')))
        }, " × "),
        _hoisted_4,
        _hoisted_5,
        _createElementVNode("button", {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('clickDisband'))),
          class: "btn"
        }, " Disband ")
      ])
    ])
  ]))
}